import {focusElement} from '@wix/panda-js-utils'
import {useEffect} from 'react'
import {useAppActions, useAppSelector} from '../../../components/details-page/Widget/hooks/runtime'
import {getActiveElement} from '../../selectors/focus-handler'

export const FocusHandler = () => {
  const {setActiveElement} = useAppActions()

  const activeElement = useAppSelector(state => getActiveElement(state.focusHandler))

  useEffect(() => {
    if (activeElement) {
      try {
        focusElement({selector: activeElement, canFocus: true})
      } catch (e) {
        console.log(e)
      } finally {
        setActiveElement(null)
      }
    }
  }, [activeElement])

  return null
}
